import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Button from '@Components/Button';
import { InfoTooltipOnClickTrigger, TooltipConstants } from '@Components/InfoTooltip';
import SelectedItemsCount from '../SelectedItemsCount';

export default function FilterToggler(props) {
  const { filter, onClick, customFilterConfig } = props;
  const title = filter.get('title');
  const expanded = filter.get('expanded');
  const groups = filter.get('groups', Map());
  const countFromDialog = filter.get('selectedItemsFromDialog') && filter.get('selectedItemsFromDialog').size;
  const groupCount = countFromDialog || groups.count((item) => item.get('selected'));

  const tooltip =
    customFilterConfig && customFilterConfig.tooltip ? (
      <InfoTooltipOnClickTrigger
        className="with-accordion-for-filter-title-tooltip"
        dataFor={TooltipConstants.ids.ResultFilterComponent}
        e2eName="info-tooltip-result-filter-component">
        {customFilterConfig.tooltip}
      </InfoTooltipOnClickTrigger>
    ) : null;

  return (
    <Button
      disabled={filter.get('disabled')}
      onClick={onClick}
      buttonConfig={{
        type: 'link',
        size: 'xs',
        label: (
          <>
            {title}
            <SelectedItemsCount count={groupCount} />
            {tooltip}
          </>
        ),
        noBorder: true,
        className: 'with-accordion-for-filter-title-wrapper',
        e2eName: 'filter-toggler',
      }}
      iconConfig={{
        name: `chevron-${expanded ? 'up' : 'down'}`,
        size: 'sm',
        className: 'with-accordion-for-filter-title-icon',
      }}
    />
  );
}

FilterToggler.propTypes = {
  filter: PropTypes.instanceOf(Map),
  customFilterConfig: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};
